import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { PlayerMix, PlayerShow, StationManagerService } from '@splixer/player';
import { FlatBrandedContent } from '../../../models';
import { Pv2DurationPlayButtonComponent } from '../../play-buttons/duration-play-button.component';
import { HngSafeHtmlComponent } from '@hidat/ng-common';

/**
 * A columnar focused rendering of the 'current-mix'.
 * Displays information about the mix, and associated program/show (if the mix has one...)
 * Does not display the playlist!
 */
@Component({
  selector: 'pv2-mix-details',
  templateUrl: 'details.component.html',
  //styleUrls: ['../player-v2-styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Pv2DurationPlayButtonComponent, HngSafeHtmlComponent],
})
export class Pv2MixDetailsComponent implements OnChanges {
  @Input() item: PlayerMix | undefined;
  @Input() flatItem: FlatBrandedContent | undefined;
  public readonly show = input<PlayerShow | undefined>(undefined);
  public readonly displayName = input<'none' | 'header' | 'inline'>('header');
  public readonly displayImage = input(true);
  public readonly displayPlayButton = input(true);
  public readonly displayDescription = input(true);

  protected station = inject(StationManagerService);
  protected hasExtendedDetails = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['item']) {
      if (this.flatItem === undefined || !changes['flatItem']) {
        this.buildComponent();
      }
    }
    if (!this.item && !this.flatItem) {
      console.error('Not item or flatItem given for Mix Details');
    }
    if (this.flatItem) {
      this.hasExtendedDetails =
        !!this.flatItem.blogLink ||
        !!this.flatItem.videoLink ||
        !!this.flatItem.credits;
    }
  }

  protected buildComponent() {
    if (this.item) {
      this.hasExtendedDetails = false;
      this.flatItem = new FlatBrandedContent(this.item);
      this.hasExtendedDetails =
        !!this.flatItem.blogLink ||
        !!this.flatItem.videoLink ||
        !!this.flatItem.credits;
    }
  }
}
